<template>
  <!-- 面包屑 -->
  <a-breadcrumb>
    <a-breadcrumb-item>任务管理</a-breadcrumb-item>
    <a-breadcrumb-item>任务库</a-breadcrumb-item>
  </a-breadcrumb>
  <!-- 功能条 -->
  <div class="tool-view">
    <a-row class="tool-row">
      <!-- 剧名 -->
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">剧名：</a-col>
          <a-col :span="18">
            <a-input
              class="tool-item"
              v-model:value="dramaNameModel"
              placeholder="请输入"
            />
          </a-col>
        </a-row>
      </a-col>
      <!-- 渠道 -->
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">渠道：</a-col>
          <a-col :span="18">
            <a-select
              class="tool-item"
              v-model:value="channelModel"
              placeholder="请选择"
            >
              <a-select-option value="">全部</a-select-option>
              <a-select-option v-for="item in channels" :key="`${item.channel_id} - ${item.name}`" :value="item.channel_id">{{ item.name }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <!-- 剧场 -->
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">剧场：</a-col>
          <a-col :span="18">
            <a-select
              show-search
              class="tool-item"
              v-model:value="theaterModel"
              placeholder="请选择"
              :filter-option="filterOption"
            >
              <a-select-option value="">全部</a-select-option>
              <a-select-option v-for="item in theaters" :key="`${item.app_id} - ${item.app_name}`" :value="item.app_id">{{ item.app_name }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <!-- 素材 -->
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">素材：</a-col>
          <a-col :span="18">
            <a-select
              show-search
              class="tool-item"
              v-model:value="materialModel"
              placeholder="请选择"
              :filter-option="filterOption"
            >
              <a-select-option value="">全部</a-select-option>
              <a-select-option :value="1">有</a-select-option>
              <a-select-option :value="2">无</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <!-- 操作 -->
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title"></a-col>
          <a-col :span="18" style="white-space: nowrap;">
            <a-button type="primary" @click="touchSearch">查询</a-button>
            <a-button style="margin-left: 16px; margin-right: 16px;" @click="touchReset">重置</a-button>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
  <!-- 列表 -->
  <a-table
    :data-source="dataSource"
    :columns="columns"
    :pagination="pagination"
    :row-key="record => record.id"
    :loading="isLoading"
    @change="handleTableChange"
  >
    <!-- 自定义行内容 -->
    <template #bodyCell="{ column, record }">
      <!-- 前台状态 -->
      <template v-if="column.key === 'status'">
        {{ (OnShelfTypes.find(item => item.value === record[column.key]) || {}).text || '-' }}
      </template>
      <!-- 频道 -->
      <template v-else-if="column.key === 'playlet_gender'">
        {{ DramaChannelTypes
          .filter(channel => (record.playlet_gender || []).includes(channel.value))
          .map(channel => channel.text)
          .join('、') || '-'
        }}
      </template>
      <!-- 操作 -->
      <template v-else-if="column.key === 'operation'">
        <a class="operation-item" @click="touchDetail(record)">任务详情</a>
      </template>
      <template v-else>
        {{ record[column.key] || '-' }}
      </template>
    </template>
  </a-table>
  <!-- 新增、编辑弹窗 -->
  <Detail ref="RefDetail" @success="getList" />
</template>

<script setup>
import { ref, reactive, onBeforeMount } from 'vue'
import { message } from 'ant-design-vue'
import { DramaChannelTypes, OnShelfTypes } from '@/utils/constantList'
import Detail from './components-task-library/Detail.vue'
import { taskList, channelSelectList, appSelectList } from '@/api/request'

// 单个子组件暴露体初始化
let RefDetail = ref(null)
// 剧名
let dramaName = ref(undefined)
let dramaNameModel = ref(undefined)
// 渠道
let channel = ref(undefined)
let channelModel = ref(undefined)
let channels = ref([])
// 剧场
let theater = ref(undefined)
let theaterModel = ref(undefined)
let theaters = ref([])
// 素材
let material = ref(undefined)
let materialModel = ref(undefined)
// 数据源
let dataSource = ref(null)
// 排序字段
let order = ref(undefined)
let orderType = ref(undefined)
// 加载
let isLoading = ref(false)
// 表头
let columns = reactive([
  {
    title: '任务ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '任务名称',
    dataIndex: 'demand_name',
    key: 'demand_name',
  },
  {
    title: '剧场名称',
    dataIndex: 'app_name',
    key: 'app_name',
  },
  {
    title: '渠道',
    dataIndex: 'channel_name',
    key: 'channel_name',
  },
  {
    title: '频道',
    dataIndex: 'playlet_gender',
    key: 'playlet_gender',
  },
  {
    title: '集数',
    dataIndex: 'total_ep',
    key: 'total_ep',
  },
  {
    title: '投稿结束时间',
    dataIndex: 'date',
    key: 'date',
  },
  {
    title: '达人数',
    dataIndex: 'daren_count',
    key: 'daren_count',
  },
  {
    title: '投稿数',
    dataIndex: 'tougao_count',
    key: 'tougao_count',
  },
  {
    title: '昨日佣金',
    dataIndex: 'yesterday_money',
    key: 'yesterday_money',
    sorter: true,
  },
  {
    title: '累计佣金',
    dataIndex: 'total_money',
    key: 'total_money',
    sorter: true,
  },
  {
    title: '任务状态',
    dataIndex: 'status',
    key: 'status',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation'
  }
])
// 分页
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})

// 钩子函数 - onBeforeMount
onBeforeMount(() => {
  // 初始化选择项列表
  getSelectList()
  // 获取列表
  getList()
})

// 初始化选择项列表
function getSelectList () {
  channelSelectList().then(res => {
    const { code, data } = res
    if (code === 0) {
      channels.value = data
    }
  })
  appSelectList().then(res => {
    const { code, data } = res
    if (code === 0) {
      theaters.value = data
    }
  })
}

// 任务详情
function touchDetail (record) {
  RefDetail.value.showDrawer(record)
}

// 查询
function touchSearch () {
  // 调整参数
  dramaName.value = dramaNameModel.value
  channel.value = channelModel.value
  theater.value = theaterModel.value
  material.value = materialModel.value
  pagination.current = 1
  // 获取列表
  getList()
}

// 重置
function touchReset () {
  dramaName.value = undefined
  dramaNameModel.value = undefined
  channel.value = undefined
  channelModel.value = undefined
  theater.value = undefined
  theaterModel.value = undefined
  material.value = undefined
  materialModel.value = undefined
  order.value = undefined
  orderType.value = undefined
  // 初始化获取
  touchSearch()
}

// 模糊匹配
function filterOption (input, option) {
  return `${option.key}`.toLowerCase().includes(`${input || ''}`.toLowerCase())
}

// 表格change
function handleTableChange (p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  order.value = ''
  orderType.value = ''
  if (sorter.columnKey) {
    order.value = sorter.columnKey
    orderType.value = sorter.order === 'descend' ? 'desc' : 'asc'
  }
  getList()
}

// 请求分页数据
function getList () {
  debugger
  isLoading.value = true
  const params = {
    name: dramaName.value,
    channel_id: channel.value,
    app_id: theater.value,
    is_cloud_link: material.value,
    order: order.value,
    order_type: orderType.value,
    page: pagination.current,
    page_size: pagination.pageSize
  }
  taskList(params).then(res => {
    isLoading.value = false
    const { code, msg, data } = res
    if (code === 0) {
      dataSource.value = data.data
      pagination.total = data.total
    } else {
      message.error(res.message || msg)
    }
  }).catch(() => {
    isLoading.value = false
  })
}
</script>

<style scoped>
.tool-view {
  width: 100%;
  display: flex;
  align-items: center;
}
.table-view {
  margin-top: 30px;
}
.tool-title:not(:first-child) {
  margin-left: 16px;
}

</style>